<style lang="less" scoped>
    .detail-from-input {
        width: 450px;
        margin: 10px 30px;
    }

    .detail-form-logo {
        margin: 16px 20px;
    }

    .margin-bt-10 {
        margin-bottom: 40px;
    }

    .detail-body-title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .upload-logo {
        width: 30%;
    }

    .app-card-style img {
        width: 350px;
        height: 160px;
        border-radius: 5px;
        cursor: pointer;
    }

    .app-card-style {
        display: flex;
        flex-direction: column;
    }

    .box {
        position: relative;
        width: 348px;
        height: 160px;
        overflow: hidden;
        border: 3px solid #4390df;
        border-radius: 6px;

    }

    .box:before {
        position: absolute;
        display: block;
        border-top: 20px solid #4390df;
        border-left: 20px solid transparent;
        right: 0;
        top: 0;
        content: "";
        z-index: 101;
    }

    .box:after {
        position: absolute;
        display: block;
        content: "\2714";
        top: -3px;
        right: 0;
        font-family: Glyphicons Halflings;
        font-size: 3pt;
        font-weight: normal;
        z-index: 102;
        color: #fff;
    }

    .img-div {
        margin: 10px 45px;
    }

    .detail-table {
        margin-top: 20px;
    }
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}} <span style="margin-left:60px;" v-if="editFlag">{{ detailForm.couponNo }}</span></div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" class="detail-form">
                    <div class="detail-form-parent-div">
                        <div class="margin-bt-10">
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="优惠券名称" prop="couponName">
                                    <el-input :disabled="editFlag" v-model="detailForm.couponName" clearable size="small" placeholder="请输入优惠券名称（20字以内）" maxlength="20"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="卡券归属" prop="couponBelong">
                                    <el-select class="full-width" :disabled="editFlag" v-model="detailForm.couponBelong" placeholder="请选择" size="small" clearable>
                                        <el-option label="支付宝卡券" value="01"></el-option>
                                        <el-option label="挚达卡券" value="02"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="发放平台" prop="provideChannel">
                                    <el-select class="full-width" :disabled="editFlag" v-model="detailForm.provideChannel" placeholder="请选择" size="small" clearable>
                                        <el-option label="支付宝" value="01"></el-option>
                                        <el-option label="有赞" value="02"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="优惠券品类" prop="couponType">
                                    <el-select class="full-width" :disabled="editFlag" v-model="detailForm.couponType" placeholder="请选择" size="small" clearable>
                                        <el-option label="公共充电抵扣券" value="01"></el-option>
                                        <el-option label="车生活洗车抵扣券" value="02"></el-option>
                                        <el-option label="车生活代驾抵扣券" value="03"></el-option>
                                        <el-option label="生活缴费抵扣券" value="05"></el-option>
                                        <el-option label="安装服务抵扣券" value="06"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="第三方活动ID" prop="couponExchangeNo">
                                    <el-input v-model="detailForm.couponExchangeNo" :disabled='editFlag' clearable placeholder="请输入第三方活动ID" maxlength="50" size="small"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="优惠券数量" prop="couponCount">
                                    <el-input v-model="detailForm.couponCount" :disabled="editFlag" clearable placeholder="请输入整张"  oninput="if(value){value=value.replace(/[^\d]/g,'')} if(value<=0){value=''} if(value>999999999){value=999999999}" size="small"></el-input>
                                    数量发放完成，则该劵无法进行兑换
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="券值" prop="prizeAmount">
                                    <el-input v-model="detailForm.prizeAmount"  Onkeyup="this.value=this.value.replace(/[^\d^\.]+/g,'').replace(/^0+(\d)/,'$1').replace(/^\./,'0.').match(/\d+.?\d{0,2}/);this.dispatchEvent(new Event('input'))" :disabled="editFlag" @input="amoutChange" clearable placeholder="请输入金额" size="small" maxlength="25"></el-input>
                                    积分比例:1元={{rate}}积分 需要<el-input style="width:80px;" disabled v-model="integral" clearable size="small" maxlength="25"></el-input>积分兑换
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="使用门槛" prop="couponUseType">
                                    <el-radio-group v-model="detailForm.couponUseType" :disabled="editFlag" @change="couponUseTypeChange">
                                        <el-radio label="01">满减</el-radio>
                                        <el-radio label="02">无门槛</el-radio>
                                    </el-radio-group> <br>
                                    满&emsp;<el-input style="width:130px;"  @input="useTypeChange"  Onkeyup="this.value=this.value.replace(/[^\d^\.]+/g,'').replace(/^0+(\d)/,'$1').replace(/^\./,'0.').match(/\d+.?\d{0,2}/);this.dispatchEvent(new Event('input'))" :disabled="isCouponUseType" v-model="detailForm.couponReductionThreshold" clearable placeholder="请输入金额" size="small" maxlength="25"></el-input>&emsp;元可用
                                    <p style="color:red;" v-if="useFlag">使用门槛需小于等于券值</p>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="开始兑换时间" prop="startExchangeTime">
                                    <el-date-picker
                                        v-model="detailForm.startExchangeTime"
                                        style="width: 320px"
                                        type="date"
                                        size="small"
                                        value-format="yyyy-MM-dd 00:00:00"
                                        range-separator="-"
                                        :disabled="editFlag"
                                       
                                    ></el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="flex">
                               
                                <el-form-item class="detail-from-input" label="结束兑换时间" prop="endTimeType">
                                    <el-radio-group v-model="detailForm.endTimeType" :disabled="editFlag" @change="endTimeTypeChange">
                                        <el-radio label="01">具体时间</el-radio>
                                        <el-radio label="02">永久</el-radio>
                                    </el-radio-group> <br>
                                    <el-date-picker
                                        v-model="detailForm.endExchangeTime"
                                        style="width: 320px"
                                        type="date"
                                        size="small"
                                        value-format="yyyy-MM-dd 23:59:59"
                                        range-separator="-"
                                       :disabled="  editFlag|| endTimeFlag"
                                       
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="卡券有效期" prop="validityDay">
                                    <el-input style="width:230px;" v-model="detailForm.validityDay" oninput="if(value){value=value.replace(/[^\d]/g,'')} if(value<=0){value=''} if(value>999999999){value=999999999}" :disabled="editFlag" clearable placeholder="请输入卡券有效期" size="small" maxlength="25"></el-input>天
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="优惠券说明" prop="couponIllustrate">
                                    <el-input  v-model="detailForm.couponIllustrate" clearable placeholder="请输入优惠券说明" size="small" maxlength="25"></el-input>
                                </el-form-item>
                            </div>
                            <div class="flex">
                                <el-form-item class="detail-from-input" label="优惠券使用规则" prop="couponRule">
                                   <el-input :rows="6" type="textarea" maxlength="500"  v-model="detailForm.couponRule" clearable placeholder="500字以内优惠券说明"></el-input>
                                </el-form-item>
                                <el-form-item class="detail-from-input" label="优惠券备注">
                                   <el-input  maxlength="50"  v-model="detailForm.remark" clearable placeholder="50字以内优惠券备注"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        
                        <div class="margin-bt-10">
                            <div class="flex">
                                <div>
                                    <el-form-item class="detail-form-logo detail-body-title"  label="优惠券图片">
                                        <el-upload class="upload-demo upload-logo" 
                                        
                                            action="" 
                                            :http-request="toUploadImg" 
                                            :on-exceed="handleExceed"
                                            :on-preview="handleLogoPreview" 
                                            :on-remove="handleLogoRemove" 
                                            :file-list="logoFileList" 
                                            :limit="1" 
                                            :before-upload="beforeAvatarUpload" 
                                            list-type="picture"
                                        >
                                            <el-button :disabled="editFlag" size="small" type="primary">点击上传</el-button>
                                            <div slot="tip" class="el-upload__tip">只能上传 jpg / jpeg / bmp / gif / png 文件(仅1张)，且不超过1M</div>
                                        </el-upload>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                       <div  class="margin-bt-10">
                        <div class="flex">
                                <div v-if="editFlag">
                                    <el-form-item class="detail-form-logo detail-body-title"  label="停用编辑">
                                        <el-radio-group v-model="couponStatusName" @click.native="statusChange($event)">
                                            <el-radio label="03">停用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                        </div>
                       </div>
                    </div>
                </el-form>
                
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" v-if="!searchFlag" :disabled="subDisabled" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                subDisabled:false,
                couponStatusName:'',
                rate:'',
                integral:'',
                isCouponUseType:false,
                endTimeType:'',
                endTimeFlag:false,
                startSearchTime:[],
                endRule:'',
                editFlag: false, //表单是否编辑状态
                disabledVersion:true,
                pageTitle: '优惠券配置ID',
                pileVersionNo:'1',
                // 默认值设置
                detailForm: {
                    couponReductionThreshold: '',
                    // pileVersionNo:'1',
                    // PileFunctionEntity:{},
                    // piletypeEntity:{},
                    // status:'Y'
                    couponEditVO:{
                        couponRule:'',
                        remark:'',
                        couponStatusName:''
                    }
                },
                stationDetailForm: {}, //电站编号
                logoFile: null, //logo图标
                logoFileList: [], //logo预览文件
                dialogVisible: false, //app卡包样式弹窗
                selectFlag: '', //选中的卡包样式
                stationTableData: [], //绑定电站数据
                contractFile: null, //上传文件
                fileList: [], //上传文件预览地址
                dealerBankDtoList: [], //运营商收款账户数据
                dealerFileDtoList: [], //运营商table表单数据
                radio: '', //收款账号是否启用
                url: '', //请求数据的url地址
                ruleArr: [], //表单验证字段
                imgArr: [], //卡包样式数据列表
                fileRadio: '',//合同是否启用
                searchFlag:false,
                useFlag:false
            }
        },
        methods: {
            amoutChange(val){
                console.log(val);
                    if(val == 0){
                        return
                    }
                    if(val == null){
                        this.integral =''
                    }else{
                        this.integral = val*this.rate
                    }
                    
            },
            getRate(){
                let _ = this
                _.$H.post(_, _.$A.coupon.integralConfigList,{}).then((res)=> {
                    _.rate = res.data.data[0].rate;
                     
                });
                
            },
            couponUseTypeChange(val){
                if(val == '02'){
                    this.isCouponUseType = true
                    // this.useFlag = false
                }else{
                    this.isCouponUseType = false
                    // if( this.detailForm.couponReductionThreshold>this.detailForm.prizeAmount){
                    // this.useFlag = true
                    // }else{
                    //     this.useFlag = false
                    // }
                }
            },
            useTypeChange(val){
                console.log(val,this.detailForm.prizeAmount);
                let num = this.detailForm.prizeAmount
                if(Number(val)>num){
                    this.useFlag = true
                }else{
                    this.useFlag = false
                }
            },
            endTimeTypeChange(val){
                if(val == '02'){
                    this.endTimeFlag = true
                    this.endRule = ''
                }else{
                    this.endTimeFlag = false
                    this.endRule = 'endExchangeTime'
                }
            },
            changeVersionNo(val){
                this.detailForm.pileVersionNo = val
            },
            //是否为编辑模式
            handleDateChange(val) {
                if (val) {
                    this.queryInfo.dtFrom = val[0];
                    this.queryInfo.dtTo = val[1];
                } else {
                    delete this.queryInfo.dtFrom;
                    delete this.queryInfo.dtTo;
                }
            },
            init() {
                // this.url = this.$A.dealer.add;
                // if(this.$store.state.editId){this
                //     this.editFlag = true;
                //     this.pageTitle = "运营商编辑";
                //     this.getFormInfo();
                //     this.url = this.$A.dealer.edit; 
                //     this.ruleArr = this.pageConfig.editRuleArr;
                //     this.getConfig();
                // }else{
                //     this.ruleArr = this.pageConfig.addRuleArr;
                // }
                console.log(this.$route.params);
                this.getRate()
                
                if (localStorage.getItem('couponDetail')) {
                    this.editFlag = true;
                    this.isCouponUseType = true
                    console.log(this.editFlag);
                    
                    
                    this.detailForm = JSON.parse(localStorage.getItem('couponDetail'))
                    this.couponStatusName = this.detailForm.couponStatusName
                    pageConfig.detailBreadCrumb[3].name = "编辑";
                    this.integral = this.detailForm.exchangePoints
                    if (this.detailForm.couponPictureUrl) {
                        let imgObj = {}
                        imgObj.name = 'pileImg';
                        imgObj.url = this.detailForm.couponPictureUrl;
                        this.logoFileList.push(imgObj);
                    }
                    if(this.detailForm.endExchangeTime){
                        this.detailForm.endTimeType = '01'
                    }else{
                        this.detailForm.endTimeType = '02'
                    }
                    // this.getFormInfo();
                    // console.log(this.detailForm.pileVersionNo);
                  
                    this.url = this.$A.coupon.edit;
                } else {
                    this.detailForm.pileVersionNo = '1'
                    this.pileVersionNo = '1'
                    // console.log(this.detailForm.pileVersionNo);
                   
                    // this.ruleArr = this.pageConfig.formRules;
                }
                if(this.$route.params.search){
                    this.searchFlag = true
                    pageConfig.detailBreadCrumb[3].name = "查看";
                }
            },
            statusChange(e){
                console.log(e);
                if (e.target.tagName === "INPUT") {
                        console.log(this.detailForm.couponStatusName);
                        if (this.couponStatusName === "") {
                        this.couponStatusName = '03'

                        } else {
                        this.couponStatusName = JSON.parse(localStorage.getItem('couponDetail')).couponStatusName
                    }
                }
            },
            // 获取表单信息
            getFormInfo() {
                let _ = this;
                _.$H.post(_, _.$A.digitization.findPileFunctionByNo,{ pileTypeNo: _.detailForm.pileTypeNo}).then((res)=> {
                    _.detailForm = res.data.data;
                    if(!_.detailForm.pileVersionNo){
                        _.detailForm.pileVersionNo = '1'
                        
                    } 
                    _.logoFileList = [];
                    if (_.detailForm.couponPictureUrl) {
                        let imgObj = {}
                        imgObj.name = 'pileImg';
                        imgObj.url = _.detailForm.couponPictureUrl;
                        _.logoFileList.push(imgObj);
                    }
                    return
                });
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                    if(_.editFlag){
                        let obj = {
                            couponRule : _.detailForm.couponRule,
                            remark : _.detailForm.remark,
                            couponStatusName : _.couponStatusName
                        }
                       _.detailForm.couponEditVO = obj
                       _.detailForm.couponBelongName = _.detailForm.couponBelong == '01'? '支付宝' :'挚达'
                       _.detailForm.provideChannelName = _.detailForm.provideChannel == '01'? '支付宝' :'有赞'
                       _.detailForm.couponTypeName = _.detailForm.couponType == '01'? '公共充电抵扣券' :_.detailForm.couponType == '02'?'车生活洗车抵扣券':_.detailForm.couponType == '03'?'':
                       _.detailForm.couponType == '03'?'车生活代驾抵扣券':_.detailForm.couponType == '05'?'生活缴费抵扣券':_.detailForm.couponType == '06'?'安装服务抵扣券':''
                       _.detailForm.exchangePoints = _.integral
                        _.$H.post(_, _.url, _.detailForm).then(res => {
                            if(res.status === 200){
                            _.$router.push({
                                name: pageConfig.listRouter
                            });
                            }
                        })
                    }else {
                       if(_.detailForm.endTimeType == '01'&&!_.detailForm.endExchangeTime){
                       return _.$message.error('请选择具体结束兑换时间')
                       }
                       if(_.detailForm.couponUseType == '01'&&!_.detailForm.couponReductionThreshold){
                       return _.$message.error('请输入具体满减金额')
                       }
                       if(_.detailForm.couponUseType == '02'){
                        _.detailForm.couponReductionThreshold = ''
                       }
                       if(_.endTimeType == '02'){
                        _.detailForm.endExchangeTime = ''
                       }
                       _.detailForm.couponBelongName = _.detailForm.couponBelong == '01'? '支付宝' :'挚达'
                       _.detailForm.provideChannelName = _.detailForm.provideChannel == '01'? '支付宝' :'有赞'
                       _.detailForm.couponTypeName = _.detailForm.couponType == '01'? '公共充电抵扣券' :_.detailForm.couponType == '02'?'车生活洗车抵扣券':_.detailForm.couponType == '03'?'':
                       _.detailForm.couponType == '03'?'车生活代驾抵扣券':_.detailForm.couponType == '05'?'生活缴费抵扣券':_.detailForm.couponType == '06'?'安装服务抵扣券':''
                       _.detailForm.exchangePoints = _.integral
                       delete _.detailForm.endTimeType
                       if(_.detailForm.endExchangeTime&&new Date(_.detailForm.startExchangeTime)>new Date(_.detailForm.endExchangeTime)){
                        return _.$message.error('开始兑换时间要小于等于结束兑换时间')
                       }
                        _.$H.post(_, _.$A.coupon.add, _.detailForm).then(res => {
                            this.subDisabled = true
                            if(res.status === 200){
                                setTimeout(() => {
                                    this.subDisabled = false
                                }, 200);
                            _.$router.push({
                                name: pageConfig.listRouter
                            });
                            }
                        })
                    }
                        // _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
                    }
                })
                // this.$refs[formName].validateField(_.ruleArr, valid => {
                //     if (valid) {
                //         suc = false;
                //     }
                //     // num++;
                //     if (suc) {
                //         _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
                //     }
                // });
            },
            changeSelect (val) {
                this.$nextTick(() => {
                    console.log(this.$refs[val]);
                    this.detailForm[val] = this.$refs[val].selected.value
                    this.detailForm[`${val}Name`] = this.$refs[val].selected.label
                    console.log(this.detailForm);
                    // for (let i = 0; i < arr.length; i++) {
                    //     console.log(arr[i].label, i)
                    // console.log(arr[i].currentValue, i)
                    //     console.log(arr[i].currentLabel, i)
                    // }
                })
            },
            //上传logo图片
            toUploadLogoImg(param) {
                this.logoFile = param.file;
            },
            handleExceed(files, fileList){
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
                // console.log(fileList);
            },
            //清楚logo图片
            handleLogoRemove(file, fileList) {
                this.detailForm.pileImgUrl = '';
                this.logoFile = null;
            },
            //预览logo
            handleLogoPreview(file) {
                console.log(file);
            },
            //上传logo图片限制
            beforeAvatarUpload(file) {
                let logoType = false;
                if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/gif' || file.type === 'image/png') {
                    logoType = true;
                }
                const isLt1M = file.size / 1024 / 1024 < 1;

                if (!logoType) {
                    this.$message.error('上传logo图片只能是 jpg / jpeg / bmp / gif / png 格式!');
                }
                if (!isLt1M) {
                    this.$message.error('上传logo图片大小不能超过 1MB!');
                }
                return logoType && isLt1M;
            },
            //上传图片
            toUploadImg(item) {
                let _ = this;
                let fd = new FormData();
                fd.append('file', item.file)
                _.$H.postFormData(_, _.$A.coupon.upload, fd).then(res => {
                    if(res.data.status === 200){
                        _.detailForm.couponPictureUrl = res.data.data.viewPath || '';
                        _.$U.success("图片上传成功！")
                    }
                })
            },
            //删除上传图片
            handleRemove(file, fileList) {
                this.contractFile = null;
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            //删除附件前提示
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>